import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MobileEmailState {
  mobileEmail: any[] | null; // Adjust 'any[]' to the actual type of your array object
}

const initialState: MobileEmailState = {
  mobileEmail: null,
};

const mobileEmailSlice = createSlice({
  name: 'mobileEmail',
  initialState,
  reducers: {
    setmobileEmail(state, action: PayloadAction<any[]>) {
      state.mobileEmail = action.payload;
    },
    clearmobileEmail(state) {
      state.mobileEmail = null;
    },
  },
});

export const { setmobileEmail, clearmobileEmail } = mobileEmailSlice.actions;
export default mobileEmailSlice.reducer;
